import * as React from "react"
import { cn } from "@/lib/utils"

const DashboardTabs = React.forwardRef(({ 
  className, 
  tabs = [],
  value,
  onValueChange,
  size = "regular",
  ...props 
}, ref) => {
  const sizeClasses = {
    small: "px-1.5 py-px",
    regular: "px-2 py-1", 
    large: "px-3 py-2"
  }

  const iconSizeClasses = {
    small: "w-4 h-4",
    regular: "w-5 h-5",
    large: "w-5 h-5"
  }

  return (
    <div
      ref={ref}
      className={cn(
        "p-1.5 bg-neutral-100 rounded-xl inline-flex justify-start items-center w-auto",
        className
      )}
      {...props}
    >
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onValueChange?.(tab.value)}
          data-state={value === tab.value ? "active" : "inactive"}
          className={cn(
            "min-w-7 min-h-7 rounded-[10px] flex justify-center items-center gap-1.5 transition-all duration-200",
            sizeClasses[size],
            "data-[state=active]:bg-white data-[state=active]:shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] data-[state=active]:shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)]",
            "data-[state=inactive]:bg-transparent hover:bg-white/50",
            "text-neutral-900 text-sm font-medium font-['Geist'] leading-tight tracking-tight"
          )}
        >
          {tab.icon && (
            <span className={cn("flex items-center justify-center", iconSizeClasses[size])}>
              {tab.icon}
            </span>
          )}
          {tab.label && (
            <span className="justify-center">
              {tab.label}
            </span>
          )}
        </button>
      ))}
    </div>
  )
})
DashboardTabs.displayName = "DashboardTabs"

export { DashboardTabs }